const SENTRY_DISABLED = false; // Set to true to disable all Sentry analytics
const MY_ORG_ID = "5c9ac16cd9bcce32ded1aea3";
const ALLOW_MY_ORG_ANALYTICS = false; // Set to true when testing analytics for your org

// Initialize Sentry with configuration
export const initializeSentry = () => {
  if (SENTRY_DISABLED) return;
  if (typeof window.Sentry !== "undefined") {
    // Check if Sentry is already initialized to prevent multiple initializations
    if (window.Sentry._isInitialized) {
      return true; // Already initialized
    }

    window.Sentry.init({
      dsn: "https://fbf680d0b1e36c0bb2e3e004551208c4@o4507645100556288.ingest.us.sentry.io/4508150777315328",
      environment: process.env.ENV_NAME || "development",
      beforeSend(event) {
        if (window.location.hostname === "localhost") {
          return null; // Don't send events from localhost
        }
        return event;
      },
      // Optional: Configure sampling for analytics events
      tracesSampleRate: 1.0,
      // Optional: Configure sampling for errors
      sampleRate: 1.0,
    });

    // Mark as initialized to prevent multiple initializations
    window.Sentry._isInitialized = true;
    return true;
  }
  return false;
};

// Helper function to safely use Sentry
export const trackSentryEvent = (eventName, properties = {}) => {
  if (SENTRY_DISABLED) return;
  // Block analytics from your org unless allowed
  if (properties.organization_id === MY_ORG_ID && !ALLOW_MY_ORG_ANALYTICS) {
    return;
  }

  // Determine environment name, default to "unknown" if not set
  const envName = process.env.ENV_NAME || "unknown";
  const envSuffix = envName !== "live" ? `_${envName}` : "";
  let eventNameWithEnv = `${eventName}${envSuffix}`;

  // Add org ID suffix if its mine
  if (properties.organization_id === MY_ORG_ID) {
    eventNameWithEnv += `_${properties.organization_id}`;
  }

  if (typeof window.Sentry !== "undefined") {
    try {
      window.Sentry.addBreadcrumb({
        category: "analytics",
        message: eventNameWithEnv,
        data: properties,
        level: "info",
      });

      window.Sentry.captureMessage(`Analytics: ${eventNameWithEnv}`, {
        level: "info",
        tags: {
          event_type: "analytics",
          event_name: eventNameWithEnv,
        },
        extra: properties,
      });
    } catch (error) {
      console.error("Error tracking Sentry event:", error);
    }
  } else if (window.location.hostname === "localhost") {
    console.log("Sentry Event (dev):", eventNameWithEnv, properties);
  }
};
